module.exports = __webpack_public_path__ + "static/media/calendar.24d30247.svg";